module.exports = __webpack_public_path__ + "img/btn_VM_runData.1ac58fd2.svg";